import React from 'react';
import { LayoutDashboard, BarChart2, Bell, User } from 'lucide-react';
import { useTokens } from '../context/ThemeContext';

const NAV_ITEMS = [
  { id: 'overview',  label: 'Transactions',  Icon: LayoutDashboard },
  { id: 'analytics', label: 'Analytics', Icon: BarChart2 },
  { id: 'budgets',   label: 'Budgets',   Icon: Bell },
];

export const SIDEBAR_WIDTH = '220px';
export const MOBILE_NAV_HEIGHT = '64px';

function Sidebar({ activeView, onViewChange, user, onProfileClick }) {
  const t = useTokens();

  const initials = user?.name
    ? user.name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2)
    : null;

  return (
    <aside style={{ width: SIDEBAR_WIDTH, backgroundColor: t.surface, borderRight: `1px solid ${t.border}`, display: 'flex', flexDirection: 'column', position: 'fixed', top: 0, left: 0, bottom: 0, zIndex: 20 }}>
      <div style={{ padding: '24px 20px 20px', borderBottom: `1px solid ${t.borderLight}` }}>
        <span style={{ fontSize: '22px', fontWeight: '600', color: t.textSlate, letterSpacing: '0.02em' }}>nura</span>
      </div>

      <nav style={{ flex: 1, padding: '16px 12px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
        {NAV_ITEMS.map(({ id, label, Icon }) => (
          <button
            key={id}
            onClick={() => onViewChange(id)}
            style={{
              display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px',
              border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer', width: '100%', textAlign: 'left', transition: 'all 0.15s',
              backgroundColor: activeView === id ? t.navActive : 'transparent',
              color: activeView === id ? t.navActiveText : t.textSecondary,
            }}
          >
            <Icon size={18} style={{ color: activeView === id ? t.navActiveIcon : t.textMuted, flexShrink: 0 }} />
            <span style={{ flex: 1 }}>{label}</span>
          </button>
        ))}
      </nav>

      <div style={{ padding: '12px', borderTop: `1px solid ${t.borderLight}` }}>
        <button
          onClick={onProfileClick}
          style={{
            display: 'flex', alignItems: 'center', gap: '10px', padding: '10px 12px',
            border: 'none', borderRadius: '8px', cursor: 'pointer', width: '100%', textAlign: 'left', transition: 'background-color 0.15s',
            backgroundColor: activeView === 'profile' ? t.navActive : 'transparent',
          }}
        >
          <div style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: t.avatarBg, color: t.avatarText, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', fontWeight: '600', flexShrink: 0 }}>
            {initials || <User size={14} />}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <span style={{ fontSize: '13px', fontWeight: '600', color: t.text, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name || 'Account'}</span>
            <span style={{ fontSize: '11px', color: t.textMuted }}>Settings & Profile</span>
          </div>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
